import { Fragment, useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import Breadcrumb from "../common/breadcrumb";
import { Link } from "react-router-dom";

import SocialProofList from "./SocialProofList";
import VideoModal from "./VideoPreviewModal";
import { adminInstance } from "../../config/axios";
import { toast } from "react-toastify";
import DeleteConfirmPopup from "../common/deleteConfirmPopup";
import { useDispatch, useSelector } from "react-redux";
import { getAllSocialProofs } from "../../reducers/adminReducers";
import Loader from "../loader/loader";

const WinnerSocialProof = () => {
  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [open, setOpen] = useState(false);
  const [activeId, setActiveId] = useState(null);
  const [loader, setLoader] = useState(false);
  const result = useSelector((state) => state.admin);
  const { socialProofData } = result || {};

  const handleAttachmentClick = (attachment) => {
    setVideoModalOpen(true);
    setSelectedVideo(attachment);
  };

  const dispatch = useDispatch();

  const handleOnDelete = async (id) => {
    try {
      setOpen(false);
      setLoader(true);
      const response = await adminInstance().delete(
        `api/admin/deleteSocialProof/${id}`
      );
      const { code } = response.data;
      if (code === 200) {
        dispatch(getAllSocialProofs());
        toast.success("Successfully Deleted", { toastId: 1 });
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const onCloseModal = () => {
    setOpen(false);
  };

  useEffect(() => {
    setLoader(true);
    dispatch(getAllSocialProofs()).then((res) => {
      if (res) {
        setLoader(false);
      }
    });
  }, [dispatch]);

  return (
    <Fragment>
      <Breadcrumb title="Winner & Social Proof" />
      <Container fluid={true}>
        <Card>
          <CardHeader>
            <h5>Social Proof </h5>
          </CardHeader>
          <CardBody>
            <Link className="btn btn-secondary" to="/create-social-proof">
              Create Social Proof
            </Link>
            {!loader ? (
              socialProofData && socialProofData.length > 0 ? (
                <SocialProofList
                  handleAttachmentClick={handleAttachmentClick}
                  setActiveId={setActiveId}
                  setOpen={setOpen}
                  socialProofData={socialProofData}
                />
              ) : (
                <p className="text-center">Data does not found</p>
              )
            ) : (
              <Loader />
            )}
          </CardBody>
        </Card>
      </Container>

      <VideoModal
        attachment={selectedVideo}
        isOpen={videoModalOpen}
        onClose={() => setVideoModalOpen(false)}
      />

      <DeleteConfirmPopup
        title={"Delete Category"}
        open={open}
        handleOnDelete={handleOnDelete}
        onCloseModal={onCloseModal}
        id={activeId}
      />
    </Fragment>
  );
};

export default WinnerSocialProof;
